import defaultTheme from './defaultTheme';
import constants from '../../constants';

export default {
  ...defaultTheme,
  layer1: '#e9eef5',
  layer2: '#e9eef5',
  inputBackground: '#fff',
  contactUsItem: '#182152',
  contactUsLabel: '#8993a8',
  contactUsValue: '#fff',
  contactUsCustomerLabel: '#182152',

  //for edit profile
  editProfileLabel: '#1a1f3f',
  editProfileRadioBtnBorder: constants.Colors.GreyBlue2,
  editProfileRadioBtn: '#040628',
  editProfileRadioInnerCircle: '#005189',
  editProfileSubmitBtn: '#005189',
  editProfileSubmitText: '#fff',
  editProfileTextInputBG: '#fff',
  editProfileTextInputErrorBG: '#f2f2eb',
  editProfileTextInputColor: '#1a1f3f',
  editProfileTextInputPlaceHolder: '#44466a',
  editProfileTextInputError: '#c3281b',

  //for verify Account Item
  verifyAccountItemContainer: constants.Colors.White,
  verifyAccountItemContainerBorder: constants.Colors.White,
  verifyAccountItemTitle: '#182152',
  verifyAccountItemContentWrapperBorder: '#cedbef',
  verifyAccountItemText: '#182152',
  verifyAccountItemViewBtn: constants.Colors.Blue,
  verifyAccountItemViewText: constants.Colors.White,
  verifyAccountItemDefault: '#008afd',
  verifyAccountItemDefaultText: '#000',
  verifyAccountItemStatusTitle: '#182152',
  verifyAccountItemStatusValue: '#8993a8',
  verifyAccountItemDefaultButton: '#182152',
  verifyAccountItemVerifyButton: '#008afd',
  verifyAccountItemDefaultButtonText: constants.Colors.White,
  verifyAccountItemIcon: '#008afd',

  ///for action sheet modal
  actionSheetHeaderLabel: '#182152',
  actionSheetBtnLabel: '#fff',
  actionSheetTakePhotoBtn: 'red',
  actionSheetChooseLibBtn: 'green',
  actionSheetContainer: '#e9eef5',

  // for settings screen
  settingScreenTest: '#ccc',
  settingScreenTitle: '#303a6d',
  settingOptionBackground: constants.Colors.White,
  settingOptionTextColor: constants.Colors.RegalBlue,

  //for pdf viewer
  pdfViewerBackground: '#fff',

  //for leaderboard user Profile
  leaderBoardProfileContainer: '#fff',
  leaderBoardHeaderContainer: '#fff',
  leaderBoardContestStatusContainer: constants.Colors.JacksonsPurple1,
  leaderBoardPhotoBackground: constants.Colors.RegalBlue,
  leaderBoardPhotoBorder: constants.Colors.RegalBlue,
  leaderBoardHeaderTitle: constants.Colors.Black2,
  leaderBoardHeaderValue: constants.Colors.RegalBlue,
  leaderBoardContestStatusText: '#000',
  leaderBoardContestStatusNameTitle: constants.Colors.White,
  leaderBoardVsText: constants.Colors.White,
  leaderBoardDivider: constants.Colors.White,

  //for referral and earn
  referEarnContentBG: '#fff',
  referEarnLabel: '#1a1f3f',
  referEarnCodeBorder: constants.Colors.Manatee,
  referEarnCode: '#1a1f3f',
  referEarnTapToCopy: '#005089',
  referEarnMessage: '#3e3f56',
  referEarnShareBtn: '#005089',
  referEarnShareBtnTitle: '#fff',

  //for analytics
  revenueAnalyticsBtnBG: '#005089',
  revenueAnalyticsBtnLabel: '#fff',
  revenueAnalyticsSubmitBtnBG: '#fff',
  revenueAnalyticsSubmitBtnLabel: '#1a1f3f',
  revenueAnalyticsCardBG: '#fff',
  revenueAnalyticsCardTitle: '#1a1f3f',
  revenueAnalyticsSpinner: '#1a1f3f',

  //for iframe page
  iframeLoader: '#1a1f3f',
  iframeLoaderMessage: '#1a1f3f'
};
